import styled from '@emotion/styled'
import { Icon } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const ConditionsContainer = styled.span`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${themeColor('greyPrimary')};
  border-bottom: 1px solid ${themeColor('greyPrimary')};
  margin-bottom: 8px;

  h4 {
    margin-top: 8px;
    margin-bottom: 0px;
  }
`

export const StyledIcon = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  font-size: 18px;
  margin-right: 10px;
  color: ${themeColor('featureHeaderIconColor')};
`

export const GateRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    margin-right: 4px;
  }
`

export const ScrollContainer = styled.div`
  overflow: auto;
  margin-bottom: -20px;
  padding-bottom: 40px;
  hr {
    margin: 20px 0;
  }
`

export const DelayTimerRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  span.icon-container {
    width: 22px;
    margin-top: -2px;
    display: flex;
    justify-content: center;
  }
  span.simValue {
    margin-left: 8px;
    margin-top: -2px;
    border: 1px solid ${themeColor('slatePrimary')};
    background-color: ${themeColor('whitePressed')};
    padding: 1px 2px 0 2px;
    font-size: 12px;
  }
`
